import { colors } from 'ui/theme/colors';
import { SvgIcon, SvgIconProps } from '../SvgIcon';
import { getColor } from '../utils';

export const Analytics = ({
  height = 18,
  width = 20,
  color = colors.grey90,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon height={height} width={width} viewBox="0 0 20 18" data-test="analytics-icon" {...props}>
    <path
      d="M1.5625 16.3125H18.4375H1.5625ZM5.5 8.4375H3.25C3.10082 8.4375 2.95774 8.49676 2.85225 8.60225C2.74676 8.70774 2.6875 8.85082 2.6875 9V16.3125H6.0625V9C6.0625 8.85082 6.00324 8.70774 5.89775 8.60225C5.79226 8.49676 5.64918 8.4375 5.5 8.4375ZM11.125 1.6875H8.875C8.72582 1.6875 8.58274 1.74676 8.47725 1.85225C8.37176 1.95774 8.3125 2.10082 8.3125 2.25V16.3125H11.6875V2.25C11.6875 2.10082 11.6282 1.95774 11.5227 1.85225C11.4173 1.74676 11.2742 1.6875 11.125 1.6875ZM16.75 5.0625H14.5C14.3508 5.0625 14.2077 5.12176 14.1023 5.22725C13.9968 5.33274 13.9375 5.47582 13.9375 5.625V16.3125H17.3125V5.625C17.3125 5.47582 17.2532 5.33274 17.1477 5.22725C17.0423 5.12176 16.8992 5.0625 16.75 5.0625Z"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
